<template>
  <RouterView #default="{ Component }">
    <component :is="Component" />
  </RouterView>
</template>

<script setup lang="ts">
const globalQuery = ref<GlobalReportQueryFilters>({
  start: undefined,
  end: undefined,
})

const setGlobalQuery = (
  value: GlobalReportQueryFilters
) => {
  globalQuery.value.start = value.start
  globalQuery.value.end = value.end
}

provide(GLOBAL_REPORT_QUERY_FILTERS_KEY, {
  globalQuery,
  setGlobalQuery,
})
</script>
